import { PageType } from "shared/lib/page-type";

export const pathname = "/newsletters/preview";

export const page = {
  route(query: QueryParameters<{ entityId?: string }>) {
    return {
      pathname,
      query: { ...query, pageType: PageType.NewsletterPreview },
    };
  },
};
